export const NOTICE_TYPE = [
  { label: '图片', value: 1 },
  { label: '文本', value: 2 }
];
